/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import React from 'react';

import { useTranslation } from 'react-i18next';

import CustomLink from 'components/CustomLink/CustomLink';
import Render from 'components/render';
import { RenderByExchange } from 'components/render/RenderByExchangeType';
import { IS_INDIAN_EXCHANGE } from 'constants/constants';
import { generateAssetUnitLabel } from 'helpers/localized';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import {
  capitalize,
  decimalMultiplication,
  getContractSpecsPageUrl,
  isOptions,
  js_yyyy_mm_dd_hh_mm_ss,
  numberCommaSeparator,
} from 'helpers/utils';
import i18n from 'i18n/config';
import { LearnMoreIcon } from 'styles/assets/icons';

import styles from './index.module.scss';

const MobileProductDetails = ({ selectedProduct }) => {
  const { t } = useTranslation(['trading']);
  const {
    symbol,
    // short_description,
    // description,
    notional_type,
    settlement_time,
    contract_type,
    spot_index,
    initial_margin,
    // quoting_asset,
    underlying_asset,
    settling_asset,
    trading_status,
    // impact_size,
    maintenance_margin,
    contract_value,
    contract_unit_currency,
    // is_quanto,
    // strike_price,
    position_size_limit,
  } = selectedProduct || {};

  const spotIndexSymbol = spot_index.symbol;
  const isMove = contract_type === 'move_options';
  const isCall = contract_type === 'call_options';
  const isPut = contract_type === 'put_options';
  const isOptionsCombos = contract_type === 'options_combos';

  const contractValue = `${contract_value} ${contract_unit_currency}`;
  const positionLimit = decimalMultiplication(position_size_limit, contract_value);
  const settlementCurrency = IS_INDIAN_EXCHANGE
    ? i18n.t('auth:inr')
    : settling_asset.symbol;
  const isOptionsContract = isOptions(contract_type);
  const isTracker = contract_type === 'tracker';

  const onFullSpecClick = () => {
    trackMixpanelEvent('See Full Contract Specifications Clicked - Trade', {
      product_name: symbol,
      product_type: contract_type,
    });
  };

  return (
    (<div
      className={styles['product-menu-container']}
      data-palette="MobileProductDetails">
      <div className={styles.header}>{t('trading:contractDetails')}</div>
      {isOptions(contract_type) ? (
        <div
          className={styles['product-details-item']}
          data-palette="MobileProductDetails">
          <div className={styles.label}>{t('trading:exerciseStyle')}</div>
          <div className={styles.value}>{t('trading:optionExerciseStyle')}</div>
        </div>
      ) : (
        <Render when={!isTracker}>
          <div className={styles['product-details-item']}>
            <div className={styles.label}>{t('trading:type')}</div>
            <div className={styles.value}>
              {notional_type === 'vanilla' ? t('trading:linear') : t('trading:inverse')}
            </div>
          </div>
        </Render>
      )}
      {(contract_type === 'futures' || isMove || isCall || isPut || isOptionsCombos) && (
        <div
          className={styles['product-details-item']}
          data-palette="MobileProductDetails">
          <div className={styles.label}>{t('trading:expiresOn')}</div>
          <div className={styles.value}>
            {js_yyyy_mm_dd_hh_mm_ss(new Date(settlement_time))}
          </div>
        </div>
      )}
      {!isOptions(contract_type) && (
        <div
          className={styles['product-details-item']}
          data-palette="MobileProductDetails">
          <div className={styles.label}>
            {generateAssetUnitLabel('trading:unitSize', {
              capitalize: true,
            })}
          </div>
          <div className={styles.value}>{contractValue}</div>
        </div>
      )}
      <Render when={isTracker}>
        <div className={styles['product-details-item']}>
          <div className={styles.label}>Min Lot Size</div>
          <div className={styles.value}>
            {selectedProduct?.product_specs?.min_order_size}
          </div>
        </div>
      </Render>
      {/* <div className={styles['product-details-item']}>
        <div className={styles.label}>{t('trading:lotSize')}</div>
        <div className={styles.value}>
          {' '}
          1 {t('trading:makerTaker.contract')}
        </div>
      </div>

      <div className={styles['product-details-item']}>
        <div className={styles.label}>{t('trading:contractVal')}</div>
        <div className={styles.value}>
          {`${is_quanto ? quantoContractValue : contractValue}`}
        </div>
      </div> */}
      <div className={styles['product-details-item']}>
        <div className={styles.label}>
          <RenderByExchange
            global={<>{i18n.t('trading:settlementCurrency')}</>}
            indian={<>{i18n.t('trading:effectiveSettlementCurrency')}</>}
          />
        </div>
        <div className={styles.value}>{settlementCurrency}</div>
      </div>
      {/* {isMove || isCall || isPut ? (
        <div className={styles['product-details-item']}>
          <div className={styles.label}>{t('trading:strikePrice')}</div>
          <div className={styles.value}>
            {Number(strike_price).toFixed(quoting_asset.minimum_precision)}
          </div>
        </div>
      ) : null} */}
      <Render when={!isOptionsContract && !isTracker}>
        <div className={styles['product-details-item']}>
          <div className={styles.label}>{t('trading:initialMargin')}</div>
          <div className={styles.value}>{parseFloat(initial_margin)} %</div>
        </div>
      </Render>
      <Render when={isOptionsContract}>
        <div className={styles['product-details-item']}>
          <div className={styles.label}>{t('trading:initialMarginShort')}</div>
          <div className={styles.value}>
            {parseFloat(initial_margin)} % {t('trading:initialMarginExtra')}
            <br />
            {t('trading:extraText')}
          </div>
        </div>
      </Render>
      <Render when={!isTracker}>
        <div className={styles['product-details-item']}>
          <div className={styles.label}>{t('trading:maxLeverage')}</div>
          <div className={styles.value}>{parseInt(100 / initial_margin, 10)}x</div>
        </div>
      </Render>
      <Render when={!isOptionsContract && !isTracker}>
        <div className={styles['product-details-item']}>
          <div className={styles.label}>{t('trading:maintenanceMargin')}</div>
          <div className={styles.value}>{parseFloat(maintenance_margin)} %</div>
        </div>
      </Render>
      <Render when={isOptionsContract}>
        <div className={styles['product-details-item']}>
          <div className={styles.label}>{t('trading:maintenanceMarginShort')}</div>
          <div className={styles.value}>
            {parseFloat(maintenance_margin)} % {t('trading:initialMarginExtra')}
            <br />
            {t('trading:extraText')}
          </div>
        </div>
      </Render>
      <div className={styles['product-details-item']}>
        <div className={styles.label}>{t('trading:underlyingIndex')}</div>
        <div className={styles.value}>
          <CustomLink
            href={`/indices/#${spotIndexSymbol}`}
            data-testid="product-details-spot-indices"
            rel="noopener noreferrer"
            target="_blank"
            className={styles.underlying_index}
          >
            {spotIndexSymbol}
          </CustomLink>
        </div>
      </div>
      <div className={styles['product-details-item']}>
        <div className={styles.label}>{t('trading:positionLimit')}</div>
        <div className={styles.value}>
          <span>
            {positionLimit} {contract_unit_currency}
          </span>
          <br />
          <span>
            {numberCommaSeparator(position_size_limit)} {t('trading:contracts')}
          </span>
          {/* {`${positionLimit} ${contract_unit_currency} (${numberCommaSeparator(
            position_size_limit
          )} ${t('trading:contracts')})`} */}
        </div>
      </div>
      {/* <div className={styles['product-details-item']}>
        <div className={styles.label}>{t('trading:impactSize')}</div>
        <div className={styles.value}>
          {parseInt(impact_size, 10)} {t('trading:contracts')}
        </div>
      </div> */}
      <div className={styles['product-details-item']}>
        <div className={styles.label}>{t('trading:status')}</div>
        <div className={styles.value}>{capitalize(trading_status)}</div>
      </div>
      <CustomLink
        data-testid="BfbaqbiPA89FMngalQFWV"
        className={styles['contract-spec-button']}
        onClick={() => onFullSpecClick()}
        href={getContractSpecsPageUrl(contract_type, symbol, underlying_asset.symbol)}
      >
        <span>{t('trading:contractSpecs')}</span> <LearnMoreIcon />
      </CustomLink>
    </div>)
  );
};

export default MobileProductDetails;
